<template>
  <van-popup
    v-model="visible"
    :close-on-click-overlay="closeOnClickOverlay"
    :get-container="getContainer"
    :style="style"
    :position="position"
    :closeable="closeable"
    :class="`${position === 'bottom' ? 'bottom' : ''}`"
    @click-overlay="$emit('click-overlay')"
  >
    <div :class="`${position === 'bottom' ? 'ios-safe' : ''}`">
      <slot></slot>
    </div>
  </van-popup>
</template>

<script>
import { getAppZoom } from '@/canvas/utils'
export default {
  name: 'BasePopup',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    getContainer: {
      type: String,
      default: 'body'
    },
    position: {
      type: String,
      default: 'center'
    },
    closeable: {
      type: Boolean,
      default: false
    },
    maxZoom: {
      type: Number,
      default: 2
    },
    overrideStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      style: {
        ...this.overrideStyle,
        zoom: Math.min(getAppZoom(), this.maxZoom)
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    visible() {
      this.show = this.visible
    }
  }
}
</script>

<style scoped lang="less">
.van-popup {
  border-radius: 10px !important;
  &.bottom {
    width: 375px !important;
    margin: 0 auto !important;
    left: 0 !important;
    right: 0 !important;
  }
}
</style>
